import { render } from "./TransformationFunctiomFormModal.vue?vue&type=template&id=1580fcc4"
import script from "./TransformationFunctiomFormModal.vue?vue&type=script&lang=js"
export * from "./TransformationFunctiomFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__